import React from 'react';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { FaTimes } from 'react-icons/fa';

import FieldController from '../../../controller/FieldController';

class ConditionComplete extends React.Component {

  onConditionChanged = condition => {
    let filter = { ...this.props.filter };
    const options = FieldController.getOptions(this.props.fields[filter.field.value]);
    filter = { ...filter, condition, value: condition?.value, options, andor: false };
    this.props.onFilterChanged(this.props.index, filter);
  }

  onValueChanged = select => {
    const value = select ? `~${select.map(val => val.value).join('~')}~` : '';
    const filter = { ...this.props.filter, select, value, condition: value };
    this.props.onFilterChanged(this.props.index, filter);
  }

  render() {
    const i = this.props.index;
    const filter = this.props.filter;
    return (
      <div key={`condition_${i}`} className="col-md-12 condition-select-div">
        {filter.field.label}
        
        <div className="condition-select col-md-3">
          <Select value={filter.condition} 
            onChange={ selected => this.onConditionChanged(selected) }
            options={filter.conditions} isSearchable={true} isClearable={true} />
        </div>

        <div>
          { false && (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
            && filter.select && filter.select.length > 1
            ? <div>
                <label>Inner Condition</label>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={filter.andor}
                    onChange={() => this.onCondition(i, true)} />
                  <Form.Check.Label>AND</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={!filter.andor}
                    onChange={() => this.onCondition(i, false)} />
                  <Form.Check.Label>OR</Form.Check.Label>
                </Form.Check>
              </div>
            : null
          }

          <Button variant="danger" onClick={() => this.props.onDelete(i)}><FaTimes /></Button>
        </div>
      </div>
    );
  }
}
export default ConditionComplete;